import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Website from './website';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Define the root ("/") route to render the Website component */}
          <Route path="/" element={<Website />} />
          {/* You can add more routes here if needed */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
